import React, { useEffect, useState } from 'react';
import LeaderboardTable from '../LeaderboardTable/LeaderboardTable.js';
import LeaderboardFilters from '../LeaderboardFilters/LeaderboardFilters.js';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.js';
import { getClanLeaderboardDate } from '../../client/api/server_api.js';
import { dateFormat } from '../../metadata/formatters.js';

const STRINGS = {
    CLAN_LEADERBOARDS: gettext("REGIMENT LEADERBOARDS"),
    LEADERBOARD_UPDATED: gettext("Battle Data current through "),
    MISSING_TIME: gettext("missing time"),
}

function Leaderboard() {
    const [leaderboardDate, setLeaderboardDate] = useState('');
    
    useEffect(() => {
        Promise.all([getClanLeaderboardDate()])
            .then(results => {
                setLeaderboardDate(results[0].data.date);
            })
            .catch((err) => {
                console.log(err);
            });
        return () => {
        }
    }, []);

    return (
        <>
            <Breadcrumbs/>
            <section>
                <h1>{STRINGS.CLAN_LEADERBOARDS}</h1>
                <section>
                    <span>{STRINGS.LEADERBOARD_UPDATED} { leaderboardDate ? dateFormat(leaderboardDate) : STRINGS.MISSING_TIME}</span>
                </section>
            </section>
            <LeaderboardTable />
        </>
    ) 
}

export default Leaderboard;
